import React from "react";
import PropTypes from "prop-types";
import { getHelpConfig } from "actions/needhelpActions";
import _ from "lodash";

// Redux
import { connect } from "react-redux";
import { injectIntl, intlShape } from "react-intl";
import messages from "components/messagesDescription";

class Needhelp extends React.Component {
  componentDidMount() {
    this.props.dispatch(getHelpConfig({ param: "" }));
  }

  render() {
    const { error, response, intl } = this.props;
    return (
      <div className="help-page-container">
        <div className="help-page">
          {response && (
            <div
              dangerouslySetInnerHTML={{
                __html:
                  response.header && !_.isEmpty(response.header)
                    ? intl.formatMessage({
                        id: response.header,
                        defaultMessage: response.header,
                        values: messages.needHelpFooter.values,
                      })
                    : response.header,
              }}
            />
          )}
          {response && (
            <div
              dangerouslySetInnerHTML={{
                __html:
                  response.footer &&
                  !_.isEmpty(response.footer) &&
                  intl.formatMessage({
                    id: response.footer,
                    defaultMessage: response.footer,
                    values: messages.needHelpFooter.values,
                  }),
              }}
            />
          )}
          {error && (
            <p>
              {intl.formatMessage({
                id: error.message,
                defaultMessage: error.message,
              })}
            </p>
          )}
        </div>
      </div>
    );
  }
}

Needhelp.propTypes = {
  dispatch: PropTypes.func,
  error: PropTypes.object,
  response: PropTypes.object,
  intl: intlShape.isRequired,
};

const mapStateToProps = function(store) {
  return {
    error: store.error,
    response: store.needhelp.response,
  };
};

export default injectIntl(connect(mapStateToProps)(Needhelp));



// WEBPACK FOOTER //
// ./components/employee/needHelp.jsx